import { useCallback } from "react";
import { STATUS, STATUS_LABEL } from "./harvestEntryConstants.js";

export function useHarvestEntryStatus({ showWeight }) {
  const getEffectiveYield = (row) =>
    row.pendingYield !== null && row.pendingYield !== undefined
      ? row.pendingYield
      : row.yield;

  const getEffectiveWeight = (row) =>
    row.pendingWeight !== null && row.pendingWeight !== undefined
      ? row.pendingWeight
      : row.weight;

  const isRowDiscarded = useCallback(
    (row) => {
      const y = getEffectiveYield(row);
      const w = getEffectiveWeight(row);
      if (!showWeight) return y === -1;
      return y === -1 || w === -1;
    },
    [showWeight],
  );

  const isBackendRowDiscarded = useCallback(
    (row) => {
      const y = row.yield;
      const w = row.weight;
      if (!showWeight) return y === -1;
      return y === -1 || w === -1;
    },
    [showWeight],
  );

  const getBackendStatus = useCallback(
    (row) => {
      if (isBackendRowDiscarded(row)) return STATUS.DISCARDED;
      if (row.is_harvested) return STATUS.HARVESTED;
      return STATUS.PLANTED;
    },
    [isBackendRowDiscarded],
  );

  const getBackendStatusText = useCallback(
    (row) => STATUS_LABEL[getBackendStatus(row)],
    [getBackendStatus],
  );

  const hasHarvestEditsPending = useCallback(
    (row) =>
      (row.pendingHarvestDate !== null &&
        row.pendingHarvestDate !== undefined) ||
      (row.pendingYield !== null && row.pendingYield !== undefined) ||
      (row.pendingWeight !== null && row.pendingWeight !== undefined),
    [],
  );

  const getEffectiveStatus = useCallback(
    (row) => {
      if (row.pendingUnharvest) return STATUS.PLANTED;
      if (isRowDiscarded(row)) return STATUS.DISCARDED;
      if (row.is_harvested || hasHarvestEditsPending(row))
        return STATUS.HARVESTED;
      return STATUS.PLANTED;
    },
    [hasHarvestEditsPending, isRowDiscarded],
  );

  const getEffectiveStatusText = useCallback(
    (row) => STATUS_LABEL[getEffectiveStatus(row)],
    [getEffectiveStatus],
  );

  const rowHasPendingChanges = useCallback(
    (row) =>
      row.pendingUnharvest ||
      (row.pendingHarvestDate !== null &&
        row.pendingHarvestDate !== undefined) ||
      (row.pendingYield !== null && row.pendingYield !== undefined) ||
      (row.pendingWeight !== null && row.pendingWeight !== undefined) ||
      (row.pendingTubWeight !== null && row.pendingTubWeight !== undefined) ||
      (row.pendingPloughedReasons !== null &&
        row.pendingPloughedReasons !== undefined) ||
      (row.pendingPloughedNote !== null &&
        row.pendingPloughedNote !== undefined),
    [],
  );

  return {
    getEffectiveYield,
    getEffectiveWeight,
    isRowDiscarded,
    isBackendRowDiscarded,
    getBackendStatus,
    getBackendStatusText,
    hasHarvestEditsPending,
    getEffectiveStatus,
    getEffectiveStatusText,
    rowHasPendingChanges,
  };
}
